<script>
import { defineComponent, onMounted } from 'vue'
import LineFunction from '@/helper/facade/LineFunction.js'
import Utility from '@/helper/Utility';
import { useRoute } from 'vue-router';
import sendtext from '../../SentText/service/sendtext'
import ConfigManager from '@/config/ConfigManager';


export default defineComponent({
    setup() {
        const route = useRoute()

        function initLiff() {
            let lineFunction = new LineFunction();
            let liffId = lineFunction.getLiffId();
            // let liffId = '1579757443-lxBeWY86'

            lineFunction.init(liffId).then(async() => {
                // alert('open https://tnivue.buzzebees-dev.com/claim-no-register?uid=123')

                // lineFunction.openExternalWindow('https://liff.line.me/1579757443-bqWGznqv?target_page=Claim.aspx&type=now')
                if (route.query.target_page == 'send_text') {
                    let currentUrl = window.location.href;
                    if (lineFunction.isLogin()) {
                        if (lineFunction.isTokenExpire()) {
                            lineFunction.logout();
                            lineFunction.login(currentUrl);
                            return;
                        }

                        let idToken = lineFunction.getIdToken();
                        let lineProfile = await lineFunction.getProfile();

                        if (idToken != null && lineProfile.userId) {                            
                            let params = {
                                text: route.query.text,
                                lineUserId: lineProfile.userId
                            }
                            
                            await apiSendText(params)

                            const lineId = ConfigManager.getLineId()
                            let urlSchemeOpenLine = "https://line.me/R/ti/p/" + lineId

                            window.location = urlSchemeOpenLine
                        }
                    } else {
                        lineFunction.login(currentUrl);
                    }
                } else {
                    let qs = new URLSearchParams(route.query).toString()
                    let arr = qs.split("&")
                    arr = arr.filter(x=> x.indexOf('liff.hback'))
                    qs = arr.join("&")
                    let targetUrl = Utility.getWebUrl(`${route.params.path ?? ''}?${qs}`)
                    lineFunction.openExternalWindow(targetUrl)
                }
            }).catch((err) => {
                alert(err)
            });
        }

        function apiSendText(params) {
            return new Promise((resolve) => {
                sendtext.apiSendMessage(params).subscribe({
                    next: (res) => {
                        resolve(res)
                    },
                    error: (error) => {
                        console.log(error)
                        alert(error)
                        resolve(null)
                    }
                })
            })
        }

        onMounted(() => {
            initLiff()
        })

        return {
        }
    }
})
</script>
<template>
    <div>
        <!-- {{ $route.query }} -->
    </div>
</template>
